import request from '@/utils/request'
import qs from 'qs'

export function queryArticles(data) {
    return request({
        url: '/api-admin/article/queryArticles',
        method: 'get',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        params: data
    })
}

export function updateArticle(data) {
    return request({
        url: '/api-admin/article/updateArticle',
        method: 'post',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        data: qs.stringify(data)
    })
}

export function deleteArticle(articleId) {
    return request({
        url: '/api-admin/article/delete',
        method: 'post',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        params: { articleId }
    })
}